import React from 'react';
import PaperPlane from '../SVGs/PaperPlane';
import BottomDisclaimer from './BottomDisclaimer';

const NoData = () => {
  return (
    <>
      <div className='AbroadCustomerDataUsageBlock_UsageCycle'>
        <div className='CycleHeader'>
          <div>
            <p className='Heading m-0 NoDataCycleHeader'>טסים לחו"ל?</p>
          </div>
        </div>
        <div className='CycleBody NodataMessage'>
          <PaperPlane />
          <p className='NoDataHeading'>כאן תוכלו לעקוב אחר שימוש הסלולר שלכם ושל בני משפחתכם בזמן שהותכם בחו"ל</p>
          <p>הצפייה בשימושים באתר לא צורכת מהחבילה</p>
        </div>
      </div>
      <BottomDisclaimer />
    </>
  );
};

export default NoData;
